import { render } from "./achievements.vue?vue&type=template&id=ebd60954&scoped=true"
import script from "./achievements.vue?vue&type=script&lang=js"
export * from "./achievements.vue?vue&type=script&lang=js"

import "./achievements.vue?vue&type=style&index=0&id=ebd60954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd60954"]])

export default __exports__